import React from "react";
import {
  DatavizBubbleChart,
  DatavizScatterPlot,
} from "@radarly/models/dataviz";
import { FullFacet } from "@radarly/models/facets";
import { SearchFragmentTerm } from "@radarly/models/search";
import { useFragmentData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsFieldMetricsBubbleChartProps {
  project: number;
  fragment: SearchFragmentTerm;
  dataviz: DatavizBubbleChart | DatavizScatterPlot;
  facet: FullFacet;
  className?: string;
  onClickPoint?: (uid: string | number) => void;
  forceReload?: boolean;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsFieldMetricsBubbleChart({
  project,
  fragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickPoint,
  ...props
}: SharedWidgetsFieldMetricsBubbleChartProps) {
  const { loading, data } = useFragmentData(project, fragment);
  const _onClickPoint = (uid: string | number) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickPoint(uid);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        data={data}
        fragment={fragment}
        isFullscreen={isFullscreen}
        onClickPoint={_onClickPoint}
        {...props}
      />
    </Loading>
  );
}
